(() => {
  if (window.KoppaEditorContent) { window.KoppaEditorContent.scan(); return; }
  const active = new Map();
  const normalize = value => value.replace(/\s+/g, ' ').trim();
  const imageKey = value => { try { return new URL(value, location.href).pathname; } catch { return value; } };
  function mount(script) {
    const id = script.dataset.sectionId;
    const section = document.getElementById(`shopify-section-${id}`);
    const root = script.dataset.productHandle ? document.querySelector(`[data-ploy-product-handle="${CSS.escape(script.dataset.productHandle)}"]`) : section?.querySelector('[data-ploy-page-root]');
    if (!root) return;
    const previous = active.get(id);
    const signature = script.textContent;
    if (active.get(id)?.root === root && active.get(id)?.script === script && active.get(id)?.signature === signature) return;
    let entries;
    try { entries = JSON.parse(script.textContent); } catch { return; }
    if (!Array.isArray(entries) || entries.some(e => !e || typeof e.original !== 'string' || !['text', 'image'].includes(e.kind) || (e.value != null && typeof e.value !== 'string'))) return;
    previous?.observer.disconnect();
    const texts = new Map();
    entries.filter(e => e.kind === 'text').forEach(e => { const key = normalize(e.original); const list = texts.get(key) || []; list.push({...e, value: e.value ?? e.original}); texts.set(key, list); });
    const textEntry = (key, node) => texts.get(key)?.find(e => !e.scope || node.parentElement?.closest(e.scope));
    const images = new Map(entries.filter(e => e.kind === 'image').map(e => [imageKey(e.original), e]));
    const knownTexts = previous?.root === root ? previous.knownTexts : new WeakMap();
    const knownImages = previous?.root === root ? previous.knownImages : new WeakMap();
    const mark = (node, entry) => {
      if (!window.Shopify?.designMode || !entry.block) return;
      const holder = document.createElement('template');
      holder.innerHTML = `<span ${entry.attributes || ''}></span>`;
      const value = holder.content.firstElementChild?.getAttribute('data-shopify-editor-block');
      if (!value) return;
      if (node.getAttribute('data-shopify-editor-block') !== value) node.setAttribute('data-shopify-editor-block', value);
    };
    let queued = false;
    const apply = () => {
      queued = false;
      observer.disconnect();
      const main = root.querySelector('main') || root;
      const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, {acceptNode(node) {
        return node.parentElement?.closest('script,style,svg,textarea,option,[contenteditable]') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }});
      let node;
      while ((node = walker.nextNode())) {
        const original = normalize(node.nodeValue);
        const saved = knownTexts.get(node);
        const entry = textEntry(original, node) || (saved && normalize(saved.value) === original ? textEntry(normalize(saved.original), node) : null);
        if (!entry) continue;
        knownTexts.set(node, entry);
        const prefix = node.nodeValue.match(/^\s*/)[0];
        const suffix = node.nodeValue.match(/\s*$/)[0];
        if (original !== normalize(entry.value)) node.nodeValue = prefix + entry.value + suffix;
        mark(node.parentElement, entry);
      }
      main.querySelectorAll('img:not([data-koppa-native-image])').forEach(img => {
        const saved = knownImages.get(img);
        const entry = images.get(imageKey(img.getAttribute('src') || '')) || (saved && images.get(imageKey(saved.entry.original)));
        if (!entry) return;
        knownImages.set(img, {entry, originalAlt: saved?.originalAlt ?? img.alt});
        const imageUrl = entry.value || entry.original;
        if (entry.value || saved?.entry.value) {
          if (img.getAttribute('src') !== imageUrl) img.setAttribute('src', imageUrl);
          img.removeAttribute('srcset');
          img.closest('picture')?.querySelectorAll('source').forEach(source => source.removeAttribute('srcset'));
        }
        const alt = entry.alt ?? saved?.originalAlt;
        if (alt != null && img.alt !== alt) img.alt = alt;
        mark(img, entry);
      });
      observer.observe(root, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['src','srcset']});
    };
    const observer = new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(apply); } });
    active.set(id, {root, observer, script, signature, knownTexts, knownImages});
    apply();
  }
  const nativePhotos = new Map();
  function scanNativePhotos() {
    document.querySelectorAll('[data-koppa-native-photo-config]').forEach(script => {
      const root = document.querySelector(`[data-ploy-product-handle="${CSS.escape(script.dataset.product)}"]`);
      const previous = nativePhotos.get(script.dataset.owner);
      const signature = script.textContent;
      if (!root || (previous?.root === root && previous?.script === script && previous?.signature === signature)) return;
      let entries;
      try { entries = JSON.parse(script.textContent); } catch { return; }
      previous?.observer.disconnect();
      const apply = () => {
        const used = new Set([...root.querySelectorAll('[data-koppa-native-image]')].map(img => img.dataset.koppaNativeImage));
        const matched = [];
        root.querySelectorAll('img').forEach(img => {
          if (img.closest('[data-ploy-product-gallery]')) return;
          const assigned = img.dataset.koppaNativeImage ? entries.find(e => e.id === img.dataset.koppaNativeImage) : null;
          const candidates = entries.filter(e => (!e.scope || img.closest(e.scope)) && imageKey(e.original) === imageKey(img.getAttribute('src') || ''));
          const entry = assigned || candidates.find(e => !used.has(e.id)) || candidates[0];
          if (!entry) return;
          img.dataset.koppaNativeImage = entry.id;
          used.add(entry.id);
          if (typeof entry.alt === 'string' && img.alt !== entry.alt) img.alt = entry.alt;
          const nextSrc = entry.value || entry.original;
          if (img.getAttribute('src') !== nextSrc) img.setAttribute('src', nextSrc);
          const responsivePicture = img.closest('picture[data-koppa-responsive]');
          if (!responsivePicture || entry.value) {
            img.removeAttribute('srcset');
            img.closest('picture')?.querySelectorAll('source').forEach(source => source.removeAttribute('srcset'));
          }
          matched.push({img, entry});
          if (window.Shopify?.designMode) {
            const holder = document.createElement('template');
            holder.innerHTML = `<span ${entry.attributes || script.dataset.editorAttributes || ''}></span>`;
            const attrs = holder.content.firstElementChild?.getAttribute('data-shopify-editor-block');
            if (attrs) img.setAttribute('data-shopify-editor-block', attrs);
          }
        });

      };
      const observer = new MutationObserver(apply);
      nativePhotos.set(script.dataset.owner, {root, script, observer, signature});
      apply(); observer.observe(root, {childList:true,subtree:true});
    });
  }
  const heroVideos = new Map();
  function scanHeroVideos() {
    document.querySelectorAll('[data-koppa-hero-video-config]').forEach(script => {
      const owner = script.dataset.owner;
      const section = document.getElementById(`shopify-section-${owner}`);
      const root = section?.querySelector('[data-ploy-page-root]') || section;
      const previous = heroVideos.get(owner);
      const signature = script.textContent;
      if (!root || (previous?.root === root && previous?.script === script && previous?.signature === signature)) return;
      let config;
      try { config = JSON.parse(script.textContent); } catch { return; }
      previous?.observer.disconnect();
      const apply = () => {
        const hero = root.querySelector('main section.hero');
        const frame = hero?.querySelector('.relative.overflow-hidden');
        if (!frame) return;
        const existing = frame.querySelector('video[data-koppa-hero-video]');
        const sources = Array.isArray(config.sources) ? config.sources.filter(source => source?.src) : [];
        if (config.enabled === false || sources.length === 0) {
          existing?.remove();
          return;
        }
        const poster = config.poster || frame.querySelector('img')?.currentSrc || frame.querySelector('img')?.src || '';
        const video = existing || document.createElement('video');
        video.dataset.koppaHeroVideo = 'men';
        video.className = 'absolute inset-0 size-full object-cover';
        video.style.objectPosition = '66% center';
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.setAttribute('aria-hidden', 'true');
        if (poster) video.poster = poster;
        if (video.dataset.koppaSources !== JSON.stringify(sources)) {
          video.replaceChildren(...sources.map(source => {
            const element = document.createElement('source');
            element.src = source.src;
            if (source.type) element.type = source.type;
            return element;
          }));
          video.dataset.koppaSources = JSON.stringify(sources);
          video.load();
        }
        if (!existing) {
          const image = frame.querySelector('img');
          image?.after(video);
        }
        video.play?.().catch(() => {});
      };
      const observer = new MutationObserver(apply);
      heroVideos.set(owner, {root, script, observer, signature});
      apply(); observer.observe(root, {childList:true,subtree:true});
    });
  }
  function scan() { document.querySelectorAll('[data-koppa-editor-content]').forEach(mount); scanNativePhotos(); scanHeroVideos(); }
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    const item = active.get(event.detail?.sectionId);
    item?.observer.disconnect(); active.delete(event.detail?.sectionId);
  });
  document.addEventListener('shopify:block:select', event => {
    const id = event.detail?.blockId;
    const match = [...document.querySelectorAll('[data-shopify-editor-block]')].find(node => {
      try { return JSON.parse(node.getAttribute('data-shopify-editor-block')).id === id; } catch { return false; }
    });
    match?.scrollIntoView({behavior:'smooth',block:'center'});
  });
  let scanQueued = false;
  function scheduleScan() {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(() => { scanQueued = false; scan(); });
  }
  const scriptObserver = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('[data-koppa-editor-content], [data-koppa-native-photo-config], [data-koppa-hero-video-config]') || node.querySelector?.('[data-koppa-editor-content], [data-koppa-native-photo-config], [data-koppa-hero-video-config]')) {
          scheduleScan();
          return;
        }
      }
    }
  });
  scriptObserver.observe(document.documentElement, {childList:true, subtree:true});
  window.KoppaEditorContent = {scan};
  scan();
})();
